var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`glowing-pattern ${_vm.blur ? 'blur' : ''}`},[_c('div',{class:`pattern ${_vm.pattern || 'top-right-corner-threads'} ${_vm.animate ? 'animate' : ''}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }